const pageTypes = {
  LOGIN: "login",
  REGISTER: "register",
};

export default pageTypes;
